var map = {
	"./asta.jpg": 5068,
	"./atlantis.jpg": 2575,
	"./cartagena.jpg": 1811,
	"./glitch.jpg": 1386,
	"./hell-bent.jpg": 2579,
	"./hello-world.jpg": 7798,
	"./ick.jpg": 9936,
	"./just-super.jpg": 4240,
	"./love-game.jpg": 7539,
	"./mr-caine.jpg": 8085,
	"./oren.jpg": 2753,
	"./risen.jpg": 3452,
	"./soul-fire.jpg": 7884,
	"./the-cleaner.jpg": 1284,
	"./the-dream-escape.jpg": 2540,
	"./the-game.jpg": 7313,
	"./the-little-things.jpg": 9781,
	"./the-magic-bag.jpg": 9501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1393;